import { KaizenAccount } from "./kaizen-account";

export class CreateKaizen {

    public kaizenCreator!: string
    public kaizenLeader!: string
    public kaizenSupportingPerson!: string[]
    public companyID	!: number;
    public shopID	!: number;
    public lineID	!: number;
    public costCenterID!: number;
    public costCenterName !: string;
    public supportingCompanyID	!: number;
    public supportingShopID	!: number;
    public supportingLineID	!: number;
    public supportingCostCenterID !: number;
    public kaizenImpactingModelID !: number;
    public companyName!: string;
    public lineName!: string;
    public shopName!:string;
    public vehicleModel!: string;
    public impactingModel!:string;
    public isYokoyenFromAnotherShop !: boolean;
    public haveBpaksID !: boolean;
    public kaizenSourceIdentifier!: string;
    public kaizenSourceID	!: number;
    public kaizenSourceDescription !: string;
    public additionalKaizenSourceDescription !: string;
    public applicableForOtherShopOrPlants!: boolean;
    public applicableToSpecificShops!: boolean;
    public applicableToAllShops!: boolean;
    public kaizenTags	!: string;
    public ringiNumber	!: string;
    public investmentAmount	!: number;

    public title	!: string;
    public description	!: string; 
    public includeCostInObeya !:boolean;
    public additionalComments !: string;

    public estimatedImplementationYear	!: string;
    public estimatedImplementationMonth	!: string;
    public estimatedImplementationDay	!: string;
    public vehicleModelID	!: number;
    
    public kaizenTypeID	!: number;
    public kaizenStateID	!: number;
    public costPerUnit !:number;

    public createdBy!: string;
    public createdOn!: string;
    public modifiedBy!: string;
    public modifiedOn!: string;
    public costConfirmedBy!: string;
    public costConfirmedOn!: string;
    public pendingRevisionBy!: string;
    public pendingRevisionOn!: string;

    public cancellationReason!: string;
    public completionDay!: string;
    public completionMonth!: string;
    public completionYear!: string;
    public progressChangedBy!: string;
    public progressChangedOn!: string;
    public cmdReviewerComments!: string;

    public kaizenNumber!: Number;
    public active!: boolean;
    public version!: number;

    public projectTypeID!: number;
    public investmentTypeID!: number;
    public rankID!: number;
    public rankDifficultyID!: number;
    public rankDecisionTiming: Date | null = null;
    public rankDecisionTimingString!: string;
    public rankChangeDescription!: string;
    public milestoneImplementedID!: number;
    public SubmittedBy!:string;
    public SubmittedOn!:Date;
    public KaizenAccount!:KaizenAccount
    public totalCost !:number[];
    public currencyID!: number;
    public currencyCode!:string;
    public fifthFormValid!:boolean;
    public reApprovalReq!:boolean;
    public locTabUpdateFlag!:boolean;
    public kaizenCreatorValid!: boolean;
    public kaizenLeaderValid!: boolean;
    public isBOD!: boolean;
    public internalTrackingNo!:string;
    public trackingRef1!:string;
    public trackingRef2!:string;
}

export class KaizenDetail extends CreateKaizen {
    public kaizenId!: string;
}

export class PostResponse {
    public succeeded!: boolean;
    public message!: string;
    public errors!: string;
    public data!: KaizenDTO
}

export class GetResponse {
    public succeeded!: boolean;
    public message!: string;
    public errors!: string;
    public data!: CreateKaizen
}

export class KaizenDTO {
    public kaizenId!: number;
    public company!: string;
    public shop!: string;
    public ringi!: string;
    public account!: string;
    public type!: string;
    public costMeasure!: string;
    public kaizenCreator!: string;
    public createdAt!: Date;
    public kaizenNumber!: number;
}

export class NotificationDTO {
    public notificationCount!: number;
    public notificationDetails!: string;
}

export class KaizenMonthlySaving {
    public kaizenMonthlySavingId!: number
    public kaizenID!: number
    public calendarMonthID!: number
    public monthlySavings!: number
    public costPerUnitSavings!: number
}

export class KaizenCombined {
    public kaizenId!: string
    public kaizenCreator!: string
    public kaizenLeader!: string
    public companyId!: number
    public companyName!: string
    public lineName!: string
    public lineID!: number
    public namCimpacted!: string
    public shopID!: number
    public costCenterName!: string
    public vehicleModelID!: number
    public modelName! : string
    public calculateSavingsImpact! : string
    public kaizenImpactingModelID! : number
    public supportingNAMC! : string
    public supportingLine! : string
    public supportingShop! : string
    public supportingCostCenter! : string
    public isYokoyenFromAnotherShop! : string
    public haveBpaksID! : string
    public kaizenSourceIdentifier! : string
    public kaizenSource! : string
    public kaizenSourceDescription! : string
    public additionalKaizenSourceDescription! : string
    public applicableForOtherShopOrPlants! : string
    public applicableToSpecificShops! : string
    public applicableToAllShops! : string
    public kaizenTags! : string
    public ringiNumber! : string
    public investmentAmount! : string
    public title! : string
    public description! : string
    public includeCostInObeya !:boolean;
    public additionalComments! : string
    public estimatedImplementationYear! : string
    public estimatedImplementationMonth! : string
    public estimatedImplementationDay! : string
    public kaizenType! : string
    public kaizenState! : string
    public kaizenStateID! : string
    public cmdReviewerComments! :string
    public createdBy! : string
    public createdOn! : string
    public modifiedBy! : string
    public modifiedOn! : string
    public costConfirmedBy! : string
    public costConfirmedOn! : string
    public pendingRevisionBy! : string
    public pendingRevisionOn! : string
    public progressChangedBy! : string
    public progressChangedOn! : string
    public keyword1! : string
    public keyword2! : string
    public keyword3! : string
    public keyword4! : string
    public keyword5! : string
    public kaizenSupportingPerson!: string[]    
    public ProjectTypeID!: number
    public projectType!: string
    public InvestmentTypeID!: number
    public investmentType!: string
    public MilestoneImplementedID!: number
    public milestoneImplemented!: string
    public rankChangeDescription!: string
    public rankDecisionTiming!: Date
    public rankDecisionTimingString!: string
    public RankDifficultyID!: number
    public rankDifficulty!: string
    public RankID!: number
    public rank!: string
    public submittedOn!: Date
    public implementationDate!: Date
    public completionDate!: Date
    public initialBudget!: number
    public updatedBudget!: number
    public q0F!: boolean
    public q1F!: boolean
    public q2F!: boolean
    public q3F!: boolean
    public actualImplementation!: string
    public forecastStatus!: string
    public kaizenNumber!: number
    public currencyID!: number
}
export class KaizenState {
    public KaizenId!: number
    public KaizenStateID!: number
    public CMDReviewerComments!: string
    public costConfirmedBy!: string;
    public pendingRevisionBy!: string;
}

export class KaizenForecastAdj {
    createdBy!: string
    createdOn!: Date
    kaizenForecastAdjustmentID!: number
    kaizenNumber!: number
    modifiedBy!: string
    modifiedOn!: Date
    originalBudget!: boolean
    q1F!: boolean
    q2F!: boolean
    q3F!: boolean
}
export class KaizenForecastAdjLive {
   public kaizenId!: number;
   public forecastAdjLive!: boolean;
}

export class KaizenAccountList {
    costDirectionsText?: string;
    costTypesText?: string;
    accountsText?: string;
    detailedAccountsText?: string;
    savingsMeasureText?: string;
}    

